/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQrySearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrdersQryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { OrdersQryData, OrdersQryService }  from './OrdersQry.service';


@Component({
  selector: 'OrdersQrySearch',
  template: require('./OrdersQrySearch.component.html'),
  providers: [OrdersQryService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrdersQrySearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objOrdersQry: OrdersQryData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private OrdersQryService: OrdersQryService

	) {
		// this.id = parseInt(params.get('id'));
		this.objOrdersQry = new OrdersQryData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objOrdersQry = new OrdersQryData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objOrdersQry.OrderID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrdersQry.OrderID;
			else
				this.filterExpression = "OrderID = " + this.objOrdersQry.OrderID;
		}
		if (this.objOrdersQry.CustomerID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objOrdersQry.CustomerID + "%'";
			else
				this.filterExpression = "CustomerID like '%" + this.objOrdersQry.CustomerID + "%'";
		}
		if (this.objOrdersQry.EmployeeID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objOrdersQry.EmployeeID;
			else
				this.filterExpression = "EmployeeID = " + this.objOrdersQry.EmployeeID;
		}
		if (this.objOrdersQry.ShipVia)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipVia = " + this.objOrdersQry.ShipVia;
			else
				this.filterExpression = "ShipVia = " + this.objOrdersQry.ShipVia;
		}
		if (this.objOrdersQry.Freight)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Freight = " + this.objOrdersQry.Freight;
			else
				this.filterExpression = "Freight = " + this.objOrdersQry.Freight;
		}
		if (this.objOrdersQry.ShipName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objOrdersQry.ShipName + "%'";
			else
				this.filterExpression = "ShipName like '%" + this.objOrdersQry.ShipName + "%'";
		}
		if (this.objOrdersQry.ShipAddress)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objOrdersQry.ShipAddress + "%'";
			else
				this.filterExpression = "ShipAddress like '%" + this.objOrdersQry.ShipAddress + "%'";
		}
		if (this.objOrdersQry.ShipCity)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objOrdersQry.ShipCity + "%'";
			else
				this.filterExpression = "ShipCity like '%" + this.objOrdersQry.ShipCity + "%'";
		}
		if (this.objOrdersQry.ShipRegion)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objOrdersQry.ShipRegion + "%'";
			else
				this.filterExpression = "ShipRegion like '%" + this.objOrdersQry.ShipRegion + "%'";
		}
		if (this.objOrdersQry.ShipPostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objOrdersQry.ShipPostalCode + "%'";
			else
				this.filterExpression = "ShipPostalCode like '%" + this.objOrdersQry.ShipPostalCode + "%'";
		}
		if (this.objOrdersQry.ShipCountry)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objOrdersQry.ShipCountry + "%'";
			else
				this.filterExpression = "ShipCountry like '%" + this.objOrdersQry.ShipCountry + "%'";
		}
		if (this.objOrdersQry.CompanyName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objOrdersQry.CompanyName + "%'";
			else
				this.filterExpression = "CompanyName like '%" + this.objOrdersQry.CompanyName + "%'";
		}
		if (this.objOrdersQry.Address)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Address like '%" + this.objOrdersQry.Address + "%'";
			else
				this.filterExpression = "Address like '%" + this.objOrdersQry.Address + "%'";
		}
		if (this.objOrdersQry.City)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND City like '%" + this.objOrdersQry.City + "%'";
			else
				this.filterExpression = "City like '%" + this.objOrdersQry.City + "%'";
		}
		if (this.objOrdersQry.Region)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Region like '%" + this.objOrdersQry.Region + "%'";
			else
				this.filterExpression = "Region like '%" + this.objOrdersQry.Region + "%'";
		}
		if (this.objOrdersQry.PostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objOrdersQry.PostalCode + "%'";
			else
				this.filterExpression = "PostalCode like '%" + this.objOrdersQry.PostalCode + "%'";
		}
		if (this.objOrdersQry.Country)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Country like '%" + this.objOrdersQry.Country + "%'";
			else
				this.filterExpression = "Country like '%" + this.objOrdersQry.Country + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}



	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrdersQry/OrdersQrySearch.component.ts